import { GridColDef } from "@mui/x-data-grid";

export const customerTierColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
  { field: "discountRate", headerName: "Discount Rate", flex: 1 },
];
